// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"powerPage__gradient-bg5__vIcdI","powerPage":"powerPage__powerPage__bAQ04"};